import { createTheme, lighten } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      //main: 'rgb(255, 56, 92)',
      main: '#41B3A3',
      //main: '#b1a296',
      //main: '#002554',
    },
    secondary: {
      main: '#595959',
    },
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    fontWeightRegular: 500,
    h1: {
      fontSize: 45,
      fontWeight: 600,
    },
    h2: {
      fontSize: 40,
      fontWeight: 600,
    },
    h3: {
      fontSize: 32,
      fontWeight: 600,
    },
    h4: {
      fontSize: 24,
      fontWeight: 600,
    },
    h5: {
      fontSize: 20,
      fontWeight: 600,
    },
    h6: {
      fontSize: 16,
      fontWeight: 600,
    },
    body1: {
      fontSize: 14,
      color: '#1D3554',
    },
    body2: {
      fontSize: 12,
      color: '#1D3554',
    },
  },
})

export default createTheme(theme, {
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 10,
          backgroundColor: lighten(theme.palette.primary.main, 0.5),
        },
        bar: {
          borderRadius: 20,
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          letterSpacing: 1.5,
          marginBottom: 10,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
        },
      },
    },
  },
})
